import Vue from 'vue'
Vue.prototype.calc = function (num1, num2, calcStr) {
      var str1, // 转换为字符串的数字
            str2,
            ws1 = 0,// ws1，ws2 用来存储传入的num的小数点后的数字的位数
            ws2 = 0,// 赋默认值，解决当整数和小数运算时倍数计算错误导致的结果误差 
            bigger,// bigger和smaller用于加，减，除法找出小的那个数字，给后面补0，解决位数不对从而造成的计算错误的问题；乘法需要将结果除两个数字的倍数之和
            smaller,// 例如：加减除法中1.001 + 2.03 ，如果不给2.03进行补0，最后会变成1001+203，数字错位导致结果错误；乘法中1.12*1.1会放大为112*11，所以结果需要除以1000才会是正确的结果，112*11/1000=1.232
            zeroCount, // 需要补充0的个数
            isExistDot1, // 传入的数字是否存在小数点
            isExistDot2,
            sum,
            beishu = 1;
      // 将数字转换为字符串
      str1 = num1.toString();
      str2 = num2.toString();
      // 是否存在小数点（判断需要计算的数字是不是包含小数）
      isExistDot1 = str1.indexOf('.') != -1 ? true : false;
      isExistDot2 = str2.indexOf('.') != -1 ? true : false;
      // 取小数点后面的位数
      if (isExistDot1) {
            ws1 = str1.split('.')[1].length;
      }

      if (isExistDot2) {
            ws2 = str2.split('.')[1].length;
      }
      // 如ws1 和 ws2 无默认值，如果num1 或 num2 不是小数的话则 ws1 或 ws2 的值将为 undefined 
      // bigger 和 smaller 的值会和预期不符
      bigger = ws1 > ws2 ? ws1 : ws2;
      smaller = ws1 < ws2 ? ws1 : ws2;

      switch (calcStr) {
            // 加减法找出小的那个数字，给后面补0，解决位数不对从而造成的计算错误的问题
            // 例如：1.001 + 2.03 ，如果不给2.03进行补0，最后会变成1001+203，数字错位导致结果错误
            case "+":
            case "-":
            case "/":
                  zeroCount = bigger - smaller;
                  for (var i = 0; i < zeroCount; i++) {
                        if (ws1 == smaller) {
                              str1 += "0";
                        }
                        else {
                              str2 += "0";
                        }
                  }
                  break;
            case "*":
                  // 乘法需要将结果除两个数字的倍数之和
                  bigger = bigger + smaller;
                  break;
            default:
                  return "暂不支持的计算类型，现已支持的有加法、减法、乘法、除法";
                  break;
      }

      // 去除数字中的小数点
      str1 = str1.replace('.', '');
      str2 = str2.replace('.', '');

      // 计算倍数，例如：1.001小数点后有三位，则需要乘 1000 变成 1001，变成整数后精度丢失问题则不会存在
      for (var i = 0; i < bigger; i++) {
            beishu *= 10; // 等价于beishu = beishu * 10;
      }
      num1 = parseInt(str1);
      num2 = parseInt(str2);
      // 进行最终计算并除相应倍数
      switch (calcStr) {
            case "+":
                  sum = (num1 + num2) / beishu;
                  break;
            case "-":
                  sum = (num1 - num2) / beishu;
                  break;
            case "*":
                  sum = (num1 * num2) / beishu;
                  break;
            case "/":
                  sum = num1 / num2;
                  /* 除数与被除数同时放大一定倍数，不影响结果，
                  所以对数字进行放大对应倍数并进行补0操作后不用另对倍数做处理 */
                  break;
            default:
                  return "暂不支持的计算类型，现已支持的有加法、减法、乘法、除法";
      }

      return sum;
}
//加
Vue.prototype.floatAdd = function (arg1, arg2) {
      var r1, r2, m;
      try {
            r1 = arg1.toString().split(".")[1].length
      } catch (e) {
            r1 = 0
      }
      try {
            r2 = arg2.toString().split(".")[1].length
      } catch (e) {
            r2 = 0
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
}
//减
Vue.prototype.floatSub = function (arg1, arg2) {
      var r1, r2, m, n;
      try {
            r1 = arg1.toString().split(".")[1].length
      } catch (e) {
            r1 = 0
      }
      try {
            r2 = arg2.toString().split(".")[1].length
      } catch (e) {
            r2 = 0
      }
      m = Math.pow(10, Math.max(r1, r2));
      //动态控制精度长度
      n = (r1 >= r2) ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

//乘
Vue.prototype.floatMul = function floatMul(arg1, arg2) {
      var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
      try {
            m += s1.split(".")[1].length
      } catch (e) {
      }
      try {
            m += s2.split(".")[1].length
      } catch (e) {
      }
      return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}
//除
Vue.prototype.floatDiv = function floatDiv(arg1, arg2) {
      var t1 = 0, t2 = 0, r1, r2;
      try {
            t1 = arg1.toString().split(".")[1].length
      } catch (e) {
      }
      try {
            t2 = arg2.toString().split(".")[1].length
      } catch (e) {
      }
      r1 = Number(arg1.toString().replace(".", ""));
      r2 = Number(arg2.toString().replace(".", ""));
      return (r1 / r2) * Math.pow(10, t2 - t1);
}
Vue.prototype.getExpressNameAbbr = function getExpressNameAbbr(name) {
      switch (name) {
            case '1':
                  return '京东'
            case '1_1':
                  return '京东'
            case '1_2':
                  return '京东'
            case '16_1':
                  return '京东'
            case '16_1a':
                  return '京东'
            case '2':
                  return '圆通'
            case '3':
                  return '德邦'
            case '3_1':
                  return ' 德邦'
            case '3_2':
                  return '德邦'
            case '4':
                  return '申通'
            case '4_4':
                  return '申通'
            case '4_0':
                  return '申通'
            case '08_4':
                  return '申通'
            case '5_1':
                  return '顺丰'
            case '13_5':
                  return '顺丰'
            case '5_2':
                  return '圆通'
            case '6_7':
                  return '韵达'
            case '6_4':
                  return '申通'
            case '4_5':
                  return '顺丰'
            case '6_5':
                  return '顺丰'
            case '8_06':
                  return '极兔'
            case '8_1':
                  return '京东'
            case '8_2':
                  return '圆通'
            case '08_2':
                  return '圆通'
            case "7_0":
                  return '菜鸟'
            case "07_0":
                  return '菜鸟'
            case "07_0e":
                  return '菜鸟'
            case "07_0p":
                  return '菜鸟'
            case '8_6':
                  return '极兔'
            case '9_0':
                  return '闪送'
            case '5_0':
                  return '顺丰'
            case '10_0':
                  return '跨越'
            case '5_11':
                  return '中通'
            case '8_11':
                  return '中通'
            case '8_12':
                  return '韵达'
            case '5_12':
                  return '韵达'
            case '07_12':
                  return '韵达'
            case '8_4':
                  return '申通'
            case '05_2':
                  return '圆通'
            case '6_1':
                  return '京东'
            case '07_1':
                  return '京东'
            case '13_1':
                  return '京东'
            case '14_1':
                  return '京东'
            case '12_0':
                  return '聚合'
            case '07_3a':
                  return '德邦'
            case '3_a1':
                  return '德邦'
            case '3_a2':
                  return '德邦'
            case '3_a3':
                  return '德邦'
            case '3_a4':
                  return '德邦'
            case '3_a5':
                  return '德邦'
            case '7_0e':
                  return '菜鸟'
            case '19_0':
                  return '壹米'
            case '5_all':
                  return '智慧'
      }
}
Vue.prototype.goPage = function goPage(str) {
      this.$router.push('/' + str)
}
Vue.prototype.getTabPriceBadge = function (type) {
      // www.pyjkd.com：批量寄3.7、商家3.5；其他平台：批量寄3.9、商家3.7
      const isPyjkd = window.location.host === 'www.pyjkd.com'
      let price
      if (type === 'more') {
            price = isPyjkd ? '3.7' : '3.9'
      } else if (type === 'business') {
            price = isPyjkd ? '3.5' : '3.7'
      } else {
            price = isPyjkd ? '3.7' : '3.9'
      }
      return ''
      // `低至${price}元起`
}
Vue.prototype.isPYJ = function () {//判断是不是便宜寄快递
      let url = window.location.host
      if (['www.pyjkd.com', 'localhost:8080'].indexOf(url) > -1) {
            this.isPYJVal = 1;
      } else {
            this.isPYJVal = -1;
      }
      console.log(this.isPYJVal,'ispyjval')
}